import { SecureStorage } from "@aparajita/capacitor-secure-storage";
import { isNativeApp } from "@/lib/native-platform";
import {
  safeLocalStorageGet,
  safeLocalStorageSet,
  safeLocalStorageRemove,
} from "@/lib/safe-browser";

const RT_AID_KEY = "rt_aid";
const RT_AID_STORAGE_KEY = "routify_secure_session";

/**
 * Cross-platform secure session token storage.
 *
 * - Native (Capacitor): Keychain (iOS) / Keystore (Android) via
 *   @aparajita/capacitor-secure-storage.
 * - Web / PWA: falls back to localStorage under the same key shape.
 *
 * This module is imported only from client-side function middleware and
 * auth flows; it never executes during SSR.
 */

export async function getSecureSessionToken(): Promise<string | null> {
  if (isNativeApp()) {
    try {
      const value = await SecureStorage.getItem(RT_AID_STORAGE_KEY);
      return value ?? null;
    } catch {
      return null;
    }
  }
  return safeLocalStorageGet(RT_AID_KEY);
}

export async function setSecureSessionToken(token: string): Promise<void> {
  if (isNativeApp()) {
    await SecureStorage.setItem(RT_AID_STORAGE_KEY, token);
    return;
  }
  safeLocalStorageSet(RT_AID_KEY, token);
}

export async function removeSecureSessionToken(): Promise<void> {
  if (isNativeApp()) {
    await SecureStorage.removeItem(RT_AID_STORAGE_KEY);
    return;
  }
  safeLocalStorageRemove(RT_AID_KEY);
}
